import { Reveal, PageShell } from "@/components/Reveal";

export default function Impressum() {
  return (
    <PageShell testid="impressum-page">
      <header
        data-testid="impressum-hero"
        className="px-6 pb-12 pt-36 md:px-12 md:pb-16 md:pt-52"
      >
        <div className="mx-auto max-w-3xl">
          <p className="mb-6 text-xs uppercase tracking-[0.4em] text-anthrazit/60">
            Dein Körper spricht mit dir
          </p>
          <h1 className="font-serif text-5xl leading-[0.95] tracking-tight text-anthrazit md:text-7xl">
            Impressum
          </h1>
        </div>
      </header>
      <section data-testid="impressum-content" className="px-6 pb-32 md:px-12 md:pb-44">
        <div className="mx-auto max-w-3xl">
          <Reveal>
            <p
              data-testid="impressum-angaben"
              className="text-sm uppercase tracking-[0.2em] text-anthrazit/55"
            >
              Angaben gemäß § 5 DDG
            </p>
          </Reveal>
          <div className="mt-14 space-y-12">
            <Reveal>
              <section data-testid="impressum-verantwortlich">
                <h2 className="mb-4 font-serif text-xl tracking-tight text-anthrazit md:text-2xl">
                  Verantwortlich
                </h2>
                <p className="text-base leading-relaxed text-anthrazit/85">
                  Carmen Hackradt
                  <br />
                  Sehestedter Str. 10
                  <br />
                  24340 Eckernförde
                  <br />
                  Deutschland
                </p>
              </section>
            </Reveal>
            <Reveal>
              <section data-testid="impressum-kontakt">
                <h2 className="mb-4 font-serif text-xl tracking-tight text-anthrazit md:text-2xl">
                  Kontakt
                </h2>
                <p className="text-base leading-relaxed text-anthrazit/85">
                  Telefon: 0162 8564347
                  <br />
                  E-Mail: kontakt@carmenhackradt.de
                </p>
              </section>
            </Reveal>
            <Reveal>
              <section data-testid="impressum-taetigkeiten">
                <h2 className="mb-4 font-serif text-xl tracking-tight text-anthrazit md:text-2xl">
                  Tätigkeiten
                </h2>
                <ul className="list-disc space-y-1.5 pl-6 text-base leading-relaxed text-anthrazit/85">
                  <li>Yoga-Lehrerin</li>
                  <li>Shiatsu-Praktikerin</li>
                  <li>Breathwork-Trainerin</li>
                  <li>Coach</li>
                </ul>
                <p className="mt-4 text-base leading-relaxed text-anthrazit/85">
                  Carmen Hackradt ist selbstständig tätig.
                </p>
              </section>
            </Reveal>
            <Reveal>
              <section data-testid="impressum-umsatzsteuer">
                <h2 className="mb-4 font-serif text-xl tracking-tight text-anthrazit md:text-2xl">
                  Umsatzsteuer
                </h2>
                <p className="text-base leading-relaxed text-anthrazit/85">
                  Es besteht keine Umsatzsteuer-Identifikationsnummer gemäß § 27a UStG.
                </p>
              </section>
            </Reveal>
            <Reveal>
              <section data-testid="impressum-streitbeilegung">
                <h2 className="mb-4 font-serif text-xl tracking-tight text-anthrazit md:text-2xl">
                  Verbraucherstreitbeilegung
                </h2>
                <p className="text-base leading-relaxed text-anthrazit/85">
                  Ich bin nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor
                  einer Verbraucherschlichtungsstelle teilzunehmen.
                </p>
              </section>
            </Reveal>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
